// import { SET_SPACES, GET_SPACES } from 'types/actions/Reports.action';
import { GET_SPACES, SET_SPACES, SET_STEP_SESSION_DATA, SET_USER_SESSION } from 'types/actions/Reports.action';
import { UserSessionModel } from 'types/models/Reports';
import { AppActions } from '../../types';

const initialState: {
    spaces: any[];
    loading: boolean;
    userSession: UserSessionModel | undefined;
    ssd: any[]
} = {
    spaces: [],
    loading: true,
    userSession: undefined,
    ssd: []
};

const Reports = (state = initialState, action: AppActions) => {
    switch (action.type) {
        case GET_SPACES:
            return {
                spaces: state.spaces,
            };
        case SET_SPACES:
            return {
                ...state,
                spaces: action.payload,
                loading: false
            };
        case SET_USER_SESSION:
            return {
                ...state,
                userSession: action.payload
            }

        case SET_STEP_SESSION_DATA:
            return {
                ...state,
                ssd: action.payload
            }
        default:
            return state;
    }
};
export default Reports;
